export class RCIDChangeEvent extends CustomEvent<string> {
  constructor(resourceId: string) {
    super('RCID_CHANGE', { detail: resourceId });
  }
}
